import gql from 'graphql-tag';

/**
 * 获取订阅列表
 */
export const fetchSubscriptionsDocument = gql`
  query subscriptions($options: SubscriptionListOptions) {
    subscriptions(options: $options) {
      items {
        id
        code
        createdAt
        updatedAt
        expireNumberOfPeriod
        currentNumberOfPeriod
        discountType
        discountAmount
        frequencyUnit
        state
        frequency
        firstShippingDate
        nextShippingDate
        lastShippingDate
        totalMoney
        orders {
          id
        }
        channels {
          id
          code
          customFields {
            shopName
            shopLogo
          }
        }
        subscriptionProducts {
          id
          productVariant {
            name
            sku
            price
            options {
              code
              name
            }
            featuredAsset {
              source
            }
          }
          product {
            id
            featuredAsset {
              source
            }
          }
          quantity
        }
      }
      totalItems
    }
  }
`;

/**
 * 获取订阅详情
 */
export const fetchSubscriptionsDetailsDocument = gql`
  query subscription($subscriptionId: String!) {
    subscription(subscriptionId: $subscriptionId) {
      id
      code
      createdAt
      updatedAt
      expireNumberOfPeriod
      currentNumberOfPeriod
      discountType
      discountAmount
      frequencyUnit
      state
      frequency
      firstShippingDate
      nextShippingDate
      lastShippingDate
      totalMoney
      shippingAddress {
        fullName
        streetLine1
        streetLine2
        city
        province
        phoneNumber
        customFields {
          district
        }
      }
      orders {
        id
        state
        createdAt
        code
        total
      }
      channels {
        id
        code
        customFields {
          shopName
          shopLogo
        }
      }
      subscriptionProducts {
        id
        productVariant {
          name
          sku
          price
          options {
            code
            name
          }
          featuredAsset {
            source
          }
        }
        product {
          id
          featuredAsset {
            source
          }
        }
        quantity
      }
      subscriptionPlan {
        id
        subscriptionInterval {
          unit
          frequency
        }
        periodAndDiscount {
          expireNumberOfPeriod
          discountType
          discountAmount
        }
      }
      subscriptionProducts {
        id
        productVariant {
          name
          sku
          price
          featuredAsset {
            source
          }
        }
        product {
          id
          featuredAsset {
            source
          }
        }
        quantity
      }
    }
  }
`;

/**
 * 修改订阅周期
 */
export const fetchUpdateSubscriptionFrequencyDocument = gql`
  mutation updateSubscriptionFrequency($frequency: Int, $subscriptionId: String!) {
    updateSubscriptionFrequency(frequency: $frequency, subscriptionId: $subscriptionId) {
      id
    }
  }
`;

/**
 * 修改订阅地址
 */
export const fetchUpdateSubscriptionAddressDocument = gql`
  mutation updateSubscriptionAddress($input: CreateAddressInput, $subscriptionId: String!) {
    updateSubscriptionAddress(input: $input, subscriptionId: $subscriptionId) {
      id
    }
  }
`;

/**
 * 获取进行中的订阅数据
 */
export const fetchSubscriptionsUnderwayDocument = gql`
  query subscriptionsUnderway {
    subscriptionsUnderway {
      id
      code
      createdAt
      updatedAt
      expireNumberOfPeriod
      currentNumberOfPeriod
      frequencyUnit
      state
      frequency
      firstShippingDate
      nextShippingDate
      lastShippingDate
      channels {
        id
        code
        customFields {
          shopName
          shopLogo
        }
      }
      orders {
        id
        state
        createdAt
        code
        customFields {
          logistics {
            id
            state
            logisticCode
            logisticInfo {
              traces {
                acceptStation
                acceptTime
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * 取消订阅
 */
export const fetchUnSubscribeDocument = gql`
  mutation unsubscribe($input: SubscritionCancelInput) {
    unsubscribe(input: $input) {
      state
      transactionId
    }
  }
`;

/**
 * 获取订阅退款操作信息
 */
export const fetchSubscriptionOperationsDocument = gql`
  query subscriptionOperations(
    $subscriptionId: String!
    $operationType: OperationSubscritionType!
  ) {
    subscriptionOperations(subscriptionId: $subscriptionId, operationType: $operationType) {
      id
      createdAt
      updatedAt
      operationType
      operationValue {
        cancelExplain
        cancelCause
        cancelMoney
        modification
        original
      }
    }
  }
`;

/**
 * 获取订单关联的礼品信息
 */
export const fetchSubscriptionCompRecordsDocument = gql`
  query subscriptionCompRecords(
    $subscriptionId: String
    $orderId: String
    $options: CompRecordListOptions
  ) {
    subscriptionCompRecords(subscriptionId: $subscriptionId, orderId: $orderId, options: $options) {
      items {
        id
        createdAt
        updatedAt
        name
        description
        img
        state
        price
        openTime
        pickTime
        type
      }
      totalItems
    }
  }
`;
